import { RequestModel } from "./request-model";
import { ActionCode } from "../enums/action-code.enum";
import { DocumentModel } from "../Uploader/Models/DocumentModel";
import { StatusCode } from "../enums/status-code.enum";
import { StepsBarConfiguration } from "./steps-bar-configuration";

export class TModel {
  constructor() {
    this.Request = new RequestModel();
    this.IsEditable = true;
    this.IsActionsEditable = true;
    this.IsSubmitted = false;
    this.Attachments = new Array<DocumentModel>();
  }

  ApplicationId: string;
  TaskId: string;
  ReferenceNumber: string;
  Request: RequestModel;
  IsSubmitted: boolean;
  IsEditable: boolean;
  IsActionsEditable: boolean;
  CurrentRequestStatus?: StatusCode
  Action?: ActionCode;
  ActionComment: string;
  Attachments: Array<DocumentModel>;
  StepsBarConfiguration: Array<StepsBarConfiguration>;
    PaymentSuccessAction?: ActionCode;

}
